export const init = () => { // eslint-disable-line import/prefer-default-export
  setAccountLink();
};

const setAccountLink = () => {
  const loginLink = document.getElementsByClassName('v65-login')[0];
  const usernameLink = document.getElementsByClassName('v65-editProfile')[0];
  const accountName = document.getElementsByClassName('account-name')[0];

  if (loginLink) {
    accountName.parentElement.replaceChild(loginLink.children[0], accountName);
  }

  if (usernameLink) {
    const username = usernameLink.textContent.split('Hello ')[1];
    accountName.textContent = username;
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/userTools.js